import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import i18n from '@/utils/i18n';

import { Container, Button } from './styles';

const LanguageSwitcher = ({ className }) => {
  const { t } = useTranslation('app');

  return (
    <Container className={className}>
      <Button
        type="button"
        disabled={i18n.isEn()}
        onClick={i18n.setEn}
        isActive={i18n.isEn()}
      >
        {t('en')}
      </Button>
      <Button
        type="button"
        disabled={i18n.isDe()}
        onClick={i18n.setDe}
        isActive={i18n.isDe()}
      >
        {t('de')}
      </Button>
    </Container>
  );
};

LanguageSwitcher.defaultProps = {
  className: '',
};

LanguageSwitcher.propTypes = {
  className: PropTypes.string,
};

export default LanguageSwitcher;
